"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_VARIANT_NAMES = exports.BUTTON_STATES = exports.BUTTON_SIZE_NAMES = void 0;

/** Names of button variants */
var BUTTON_VARIANT_NAMES = ["primaryBlack", "primaryWhite", "primaryBlue", "primaryGray", "secondaryBlack", "secondaryBlue", "secondaryWhite", "secondaryNeutral", "tertiary"];
/** Name of treatments */

exports.BUTTON_VARIANT_NAMES = BUTTON_VARIANT_NAMES;
var BUTTON_STATES = ["default", "hover", "focus", "active", "loading", "disabled", "success"];
/** Possible states that require styling */

exports.BUTTON_STATES = BUTTON_STATES;

/** Names of button sizes */
var BUTTON_SIZE_NAMES = ["small", "large"];
/** Available sizes */

exports.BUTTON_SIZE_NAMES = BUTTON_SIZE_NAMES;
//# sourceMappingURL=types.js.map